/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { CredentialClaimLinkedFileValue } from './CredentialClaimLinkedFileValue';

export const FileClaimValue: core.serialization.ObjectSchema<serializers.FileClaimValue.Raw, Truvity.FileClaimValue> =
    core.serialization.object({
        value: CredentialClaimLinkedFileValue,
    });

export declare namespace FileClaimValue {
    export interface Raw {
        value: CredentialClaimLinkedFileValue.Raw;
    }
}
